module.exports = __webpack_public_path__ + "img/onayla-logo.fc75b12f.svg";